<template>
  <div>
    <section>
      <div class="title">我的钱包</div>
      <div class="wallet-container" v-loading="balanceLoading">
        <div class="wallet-content">
          <div class="wallet-content-overview">
            <div class="overview-top">
              <div class="overview-top-title">账号余额</div>
              <div class="overview-top-amount">
                ￥{{ priceFormat(balance.current_money) }}
              </div>
            </div>
            <div class="overview-bottom">
              <div class="overview-bottom-item">
                <div class="item-title">申请金额</div>
                <div class="item-amount">
                  ￥{{ priceFormat(balance.apply_money) }}
                </div>
              </div>
              <div class="overview-bottom-item">
                <div class="item-title">预计扣税</div>
                <div class="item-amount">
                  ￥{{ priceFormat(Math.round(balance.tax_money * 100) / 100) }}
                </div>
              </div>
              <div class="overview-bottom-item">
                <div class="item-title">税后金额</div>
                <div class="item-amount">
                  ￥{{
                    priceFormat(Math.round(balance.reality_money * 100) / 100)
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="wallet-content-withdraw">
            <div class="withdraw-time">
              <p>预计到账日期</p>
              <div>次月15号之前</div>
            </div>
            <div class="withdraw-btn">
              <el-button
                type="primary"
                class="mb-12"
                :loading="applyLoading"
                :disabled="
                  balance.apply_money === 0 ||
                    !authPermissions.includes(
                      'expert_service.api.fuwu_admin.wallets.withdrawal'
                    )
                "
                @click="applyWithdraw"
              >
                申请提现
              </el-button>
              <div
                style="font-size:12px;color:#909399"
                v-if="balance.apply_money === 0"
              >
                <i class="el-icon-info"></i>
                当前只能提现上个周期的收入
              </div>
            </div>
          </div>
        </div>
        <div class="wallet-tips">
          <div class="wallet-tips-title">小贴士：</div>
          <div>
            1.
            提现说明：提现结算周期为当月2日零点至下月1日23:59，期间您可以在任意时间发起提现申请（本月份只能提现上个月份）。
          </div>
          <div>
            2.
            到账说明：平台会在每月1日后的第一个工作日开始上一个提现周期的核算工作，核算完成后会在每月15日前完成上一结算周期的打款。
          </div>
          <!-- <div>
            3. 联系我们：如有任何问题，欢迎<el-link
              type="primary"
              :underline="false"
              >【问题反馈】</el-link
            >中提交给我们。
          </div> -->
        </div>
      </div>
    </section>
    <section
      v-if="
        authPermissions.includes(
          'expert_service.api.fuwu_admin.wallets.incode_withdrwal'
        )
      "
    >
      <el-tabs v-model="activeName" type="card" @tab-click="switchTabs">
        <el-tab-pane name="incomes" label="收入明细">
          <el-table
            key="incomes"
            :data="walletList"
            :stripe="true"
            v-loading="listLoading"
          >
            <el-table-column
              label="交易时间"
              prop="created_at"
            ></el-table-column>
            <el-table-column label="收入来源" prop="type">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.resource_type_label }} - {{ scope.row.type }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="交易金额">
              <template slot-scope="scope">
                <span class="success-color"
                  >+ {{ priceFormat(scope.row.amount) }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="交易状态">交易成功</el-table-column>
            <el-table-column
              label="提现状态"
              prop="status_label"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane name="withdraws" label="提现列表">
          <el-table
            key="withdraws"
            :data="withDrawList"
            :stripe="true"
            v-loading="listLoading"
          >
            <el-table-column
              label="提现时间"
              prop="created_at"
            ></el-table-column>
            <el-table-column label="提现金额" prop="total_amount">
              <template slot-scope="scope">
                <div class="danger-color">
                  - {{ priceFormat(scope.row.total_amount) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="纠偏金额" prop="after_tax_amount">
              <template slot-scope="scope">
                <div>
                  {{ priceFormat(scope.row.real_amount) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="税后实际收入" prop="real_amount">
              <template slot-scope="scope">
                <div class="success-color">
                  + {{ priceFormat(scope.row.after_tax_amount) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="提现类型" prop="type"></el-table-column>
            <el-table-column
              label="提现状态"
              prop="status_label"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  :underline="false"
                  @click="showDetail(scope.row)"
                  >查看详情</el-link
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>

      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        @current-change="handleChangePage"
        :current-page.sync="pagination.currentPage"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :hide-on-single-page="true"
      >
      </el-pagination>
    </section>

    <!-- <el-dialog title="入账详情" width="500px" :visible.sync="entryVisible">
      <div class="detail-info" v-loading="dialogLoading">
        <div>交易状态：交易成功</div>
        <div>交易类型：入账</div>
        <div>交易金额：¥ {{ priceFormat(entryInfo.current_money) }}</div>
        <div>入账来源：{{ entryInfo.resource_label }}</div>
      </div>
    </el-dialog> -->

    <el-dialog
      title="提现详情"
      width="700px"
      :visible.sync="withdrawalVisible"
      :before-close="handleClose"
    >
      <div class="detail-info" v-loading="dialogLoading">
        <div>
          交易账号：{{
            isView ? withdrawalInfo.bank_no : withdrawalInfo.hide_bank_no
          }}
          <i
            class="el-icon-view ml-12"
            style="cursor:pointer;"
            @click="handleSwitchView"
          ></i>
        </div>
        <div>交易银行：{{ withdrawalInfo.bank_name }}</div>
        <div>账户姓名：{{ withdrawalInfo.realname }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import billService from "@/global/service/bill";

export default {
  data() {
    return {
      applyLoading: false,
      balanceLoading: true,
      listLoading: true,
      dialogLoading: false,
      balance: {
        current_money: "0.00",
        apply_money: "0.00",
        reality_money: "0.00",
        tax_money: "0.00",
        exists_bankacccounts: null
      },
      walletList: [],
      pagination: {
        currentPage: 1,
        pageSize: 6,
        total: 0
      },
      entryVisible: false,
      entryInfo: {
        current_money: "",
        resource_label: null
      },
      withdrawalVisible: false,
      withdrawalInfo: {
        bank_branch: "",
        bank_name: "",
        bank_no: "",
        realname: ""
      },
      activeName: "incomes",
      withDrawList: [],
      isView: false
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getBalance();
    this.getList();
  },
  methods: {
    getBalance() {
      this.balanceLoading = true;
      billService
        .balance()
        .then(res => {
          this.balance = res;
        })
        .finally(() => {
          this.balanceLoading = false;
        });
    },
    getList() {
      const params = {
        page: this.pagination.currentPage,
        page_size: this.pagination.pageSize
      };
      this.listLoading = true;
      billService
        .financeIncomes(params)
        .then(res => {
          this.walletList = res.list;
          this.pagination.currentPage = Number(res.pagination.current_page);
          this.pagination.total = Number(res.pagination.total);
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    getWithdraws() {
      this.listLoading = true;
      const params = {
        page: this.pagination.currentPage,
        page_size: this.pagination.pageSize
      };
      billService
        .financeWithdraws(params)
        .then(res => {
          this.withDrawList = res.list;
          this.pagination.currentPage = res.pagination.current_page;
          this.pagination.total = res.pagination.total;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleChangePage(e) {
      this.pagination.currentPage = e;
      if (this.activeName === "incomes") {
        this.getList();
      } else {
        this.getWithdraws();
      }
    },
    applyWithdraw() {
      this.applyLoading = true;
      const params = {
        year_month: this.balance.year_month
      };
      billService
        .createFinanceWithdraws(params)
        .then(() => {
          this.$message.success("申请成功");
          this.pagination.currentPage = 1;
          this.getBalance();
          this.getList();
        })
        .finally(() => {
          this.applyLoading = false;
        });
    },
    showDetail(item) {
      this.withdrawalInfo = item.teacher_bank_info;
      let hide_bank_no = item.teacher_bank_info.bank_no.replace(
        /^(\d{4})\d+(\d{4})$/,
        "$1 **** **** $2"
      );
      this.withdrawalInfo.hide_bank_no = hide_bank_no;
      this.withdrawalVisible = true;
    },
    handleClose() {
      this.withdrawalVisible = false;
      this.isView = false;
    },
    handleSwitchView() {
      this.isView = !this.isView;
    },
    priceFormat(price) {
      price = price.toString();
      if (price.indexOf(".") === -1) {
        price = price + ".00";
      }
      switch (true) {
        case price.length < 7:
          return price;
        case price.length < 10:
          price = price.split("");
          price.splice(-6, 0, " ");
          return price.join("");
        case price.length < 13:
          price = price.split("");
          price.splice(-6, 0, " ");
          price.splice(-10, 0, " ");
          return price.join("");
        case price.length < 16:
          price = price.split("");
          price.splice(-6, 0, " ");
          price.splice(-10, 0, " ");
          price.splice(-14, 0, " ");
          return price.join("");
        default:
          return price;
      }
    },
    switchTabs(e) {
      this.pagination.currentPage = 1;
      if (e.name === "withdraws") {
        this.getWithdraws();
      } else {
        this.getList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.wallet-container {
  margin-bottom: 60px;
  background: #f0f2f7;
  .wallet-content {
    display: flex;
    .wallet-content-overview {
      flex: 1;
      border-right: 1px solid #fff;
      .overview-top {
        padding: 60px;
        text-align: center;
        border-bottom: 1px solid #fff;
        .overview-top-title {
          margin-bottom: 12px;
          height: 36px;
          font-size: 20px;
          line-height: 36px;
          color: #606266;
        }
        .overview-top-amount {
          height: 60px;
          font-size: 48px;
          line-height: 60px;
          color: #303133;
        }
      }
      .overview-bottom {
        display: flex;
        .overview-bottom-item {
          flex: 1;
          padding: 20px 0;
          text-align: center;
          &:nth-child(-n + 2) {
            border-right: 1px solid #fff;
          }
          .item-title {
            margin-bottom: 12px;
            height: 20px;
            font-size: 16px;
            line-height: 20px;
            color: #606266;
          }
          .item-amount {
            height: 20px;
            font-size: 18px;
            line-height: 20px;
            color: #303133;
          }
        }
      }
    }
    .wallet-content-withdraw {
      display: flex;
      flex-direction: column;
      flex: 0 0 300px;
      text-align: center;
      .withdraw-time {
        flex: 1;
        font-size: 18px;
        line-height: 36px;
        text-align: center;
        border-bottom: 1px solid #fff;
        p {
          margin-top: 48px;
          color: #606266;
        }
        div {
          color: #303133;
        }
      }
      .withdraw-btn {
        flex: 1;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
      }
    }
  }
  .wallet-tips {
    padding: 12px 24px;
    border-top: 1px solid #fff;
    .wallet-tips-title {
      margin-bottom: 8px;
      height: 20px;
      line-height: 20px;
      color: #909399;
    }
    div {
      height: 25px;
      font-size: 14px;
      line-height: 25px;
      color: #606266;
    }
  }
}
.detail-info {
  margin-left: 48px;
  div {
    margin-bottom: 12px;
  }
  p {
    margin-bottom: 4px;
  }
  .el-table {
    margin-bottom: 24px;
    width: 555px;
    tr th,
    tr td {
      padding: 4px !important;
      font-size: 12px !important;
    }
  }
}
</style>
